export const PLUGIN_HOST_DOMAIN = process.env.VUE_APP_HOST_DOMAIN || 'plugin-erp.com';
export const HESBA_HOST_DOMAIN = process.env.VUE_APP_HESBA_HOST_DOMAIN || 'hesbaksa.com';

const RESERVED_SUBDOMAINS = new Set(['www', 'api', 'reporting', 'reporting2']);

function currentHostname() {
  if (typeof window === 'undefined' || !window.location) return '';
  return window.location.hostname || '';
}

function currentHost() {
  if (typeof window === 'undefined' || !window.location) return '';
  return window.location.host || '';
}

function hostnameOf(host) {
  if (!host) return '';
  return String(host).split(':')[0];
}

export function hostMatchesDomain(host, domain) {
  const hostname = hostnameOf(host).toLowerCase();
  const apex = String(domain || '').toLowerCase();
  if (!hostname || !apex) return false;
  // binfares.hesbaksa.com matches hesbaksa.com; binfares itself does not.
  return hostname === apex || hostname.endsWith(`.${apex}`);
}

export function isHesbaHost(host = currentHostname()) {
  return hostMatchesDomain(host, 'hesbaksa.com') || hostMatchesDomain(host, HESBA_HOST_DOMAIN);
}

export function isPluginHost(host = currentHostname()) {
  return hostMatchesDomain(host, PLUGIN_HOST_DOMAIN);
}

export function getAppHostDomain(host = currentHostname()) {
  if (isHesbaHost(host)) return HESBA_HOST_DOMAIN;
  return PLUGIN_HOST_DOMAIN;
}

export const APP_HOST_DOMAIN = PLUGIN_HOST_DOMAIN;

export function getSupportWhatsAppNumber() {
  return isHesbaHost()
    ? process.env.VUE_APP_HESBA_WHATSAPP_NUMBER
    : process.env.VUE_APP_PLUGIN_WHATSAPP_NUMBER;
}
export function defaultIsHesbaClientForHost(host = currentHostname()) {
  if (isHesbaHost(host)) return true;
  return String(process.env.VUE_APP_DEFAULT_IS_HESBA_CLIENT).toLowerCase() === 'true';
}

export const DEFAULT_IS_HESBA_CLIENT = defaultIsHesbaClientForHost();

export function isProductionAppHost(host = currentHost()) {
  const hostname = hostnameOf(host).toLowerCase();

  if (hostname === 'test.plugin-erp.com' || hostname === 'test.hesbaksa.com')
    return false;
  return isHesbaHost(host) || isPluginHost(host);
}

export function getTenantSubdomainFromHost(hostname = currentHostname()) {
  const appHost = isHesbaHost(hostname)
    ? HESBA_HOST_DOMAIN
    : isPluginHost(hostname)
      ? PLUGIN_HOST_DOMAIN
      : null;

  if (!appHost) return null;

  const sub = hostnameOf(hostname).split('.')[0];
  const apexLabel = appHost.split('.')[0];

  if (!sub || RESERVED_SUBDOMAINS.has(sub) || sub === apexLabel) return null;
  return sub;
}
